angular.module('gym.calendar').factory('Events', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('calendar').all('events');
}]);
